"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileItem = exports.Form = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var form_1 = require("remota-client/component/form");
var file_1 = require("remota-client/hook/file");
var enum_1 = require("remota-common/enum");
var notification_1 = require("remota-client/hook/notification");
var logo_1 = __importDefault(require("./logo"));
var translate_1 = require("remota-common/util/translate");
var fat_1 = require("remota-common/util/fat");
var fat_2 = require("remota-common/util/fat");
var NUMBER_OF_MAXIMUM_FILES = 100;
// TODO: 画像D&D対応
var Form = function (props) {
    var job = props.job, useJobRun = props.useJobRun, useVoucherExternalUpload = props.useVoucherExternalUpload;
    var _a = __read(useJobRun(true), 1), run = _a[0];
    var notify = (0, notification_1.useNotify)();
    var _b = __read(react_1.default.useState([]), 2), states = _b[0], setStates = _b[1];
    react_1.default.useEffect(function () {
        // すべてのファイルがアップロードされたらジョブを蹴る
        // 複数ファイルアップロードの途中でコケた場合、ジョブが実行されない。
        // その場合は手動でジョブを蹴ってもらうように指示する
        var filteredStates = states.filter(function (state) { return state.job.id === job.id; });
        if (filteredStates.length > 0 && filteredStates.every(function (state) { return state.isFinished; })) {
            run(job, enum_1.BatchTrigger.UPLOAD, Date.now());
            notify({ message: (0, fat_1.deFat)((0, translate_1.fat)("アップロードが完了しました。")), severity: "success" });
            setStates([]);
        }
    }, [job, run, states, notify]);
    var handleFile = react_1.default.useCallback(function (file) {
        setStates(function (state) { return state.concat({ job: job, file: file, isFinished: false }); });
    }, [job]);
    var handleFinish = react_1.default.useCallback(function (index) {
        setStates(function (states) {
            var otherJobStates = states.filter(function (s) { return s.job.id !== job.id; });
            return __spreadArray(__spreadArray([], __read(otherJobStates), false), __read(states
                .filter(function (s) { return s.job.id === job.id; })
                .map(function (state, i) { return (i !== index ? state : __assign(__assign({}, state), { isFinished: true })); })), false);
        });
    }, [job.id]);
    return (react_1.default.createElement(Root, null,
        react_1.default.createElement(Container, null,
            react_1.default.createElement(Box, { style: { marginBottom: 32 } },
                react_1.default.createElement(logo_1.default, null)),
            react_1.default.createElement(Title, null,
                react_1.default.createElement(MainTitle, null,
                    react_1.default.createElement(Prefix, null,
                        react_1.default.createElement(fat_2.Fat, { id: (0, translate_1.fat)("宛先") }),
                        "\uFF1A"),
                    job.inputs[0].configs[1]),
                react_1.default.createElement(SubTitle, null,
                    "\uFF08",
                    react_1.default.createElement(fat_2.Fat, { id: (0, translate_1.fat)("取込方法") }),
                    "\uFF1A",
                    job.name,
                    "\uFF09")),
            react_1.default.createElement(Pre, null, job.inputs[0].configs[2]),
            react_1.default.createElement(Box, null,
                react_1.default.createElement(form_1.DropFile, { onFile: handleFile, accept: "image/jpeg,application/pdf", label: (0, fat_1.deFat)((0, translate_1.fat)("画像を選択")), multiple: true, numberOfMaximumFiles: NUMBER_OF_MAXIMUM_FILES, uploading: !!states.length, messageWhenExceedingMaximumFiles: (0, fat_1.deFat)((0, translate_1.fat)("ファイルのアップロードに失敗しました。一括アップロード可能な証憑ファイルは100件までです。")) })),
            states
                .filter(function (s) { return s.job.id === job.id; })
                .map(function (state, index) { return (react_1.default.createElement(exports.FileItem, { key: index, index: index, job: job, file: state.file, onFinish: handleFinish, useVoucherExternalUpload: useVoucherExternalUpload })); }),
            [
                [(0, fat_1.deFat)((0, translate_1.fat)("ファイル形式：")), (0, fat_1.deFat)((0, translate_1.fat)("PDFまたはJPG形式"))],
                [(0, fat_1.deFat)((0, translate_1.fat)("ファイル数：")), (0, fat_1.deFat)((0, translate_1.fat)("100件まで同時に選択ができます"))],
                [(0, fat_1.deFat)((0, translate_1.fat)("1ファイルあたりのファイルサイズ：")), (0, fat_1.deFat)((0, translate_1.fat)("5MBまでが推奨、10MB以内でご対応ください"))],
                [(0, fat_1.deFat)((0, translate_1.fat)("1ファイルあたりのページ数：")), (0, fat_1.deFat)((0, translate_1.fat)("20ページ程度が推奨、30ページ以内でご対応ください"))],
            ].map(function (_a, index) {
                var _b = __read(_a, 2), prefix = _b[0], text = _b[1];
                return (react_1.default.createElement(Note, { key: index },
                    react_1.default.createElement(NoteLeft, null, prefix),
                    react_1.default.createElement(NoteRight, null, text)));
            }))));
};
exports.Form = Form;
var Note = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 8px 0;\n  display: flex;\n  font-size: 14px;\n"], ["\n  margin: 8px 0;\n  display: flex;\n  font-size: 14px;\n"])));
var NoteLeft = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 250px;\n"], ["\n  width: 250px;\n"])));
var NoteRight = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: calc(100% - 250px);\n"], ["\n  width: calc(100% - 250px);\n"])));
var Box = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: center;\n  margin-bottom: 24px;\n"], ["\n  text-align: center;\n  margin-bottom: 24px;\n"])));
var Prefix = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 16px;\n  font-weight: normal;\n"], ["\n  font-size: 16px;\n  font-weight: normal;\n"])));
var Title = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  text-align: center;\n  margin-bottom: 24px;\n  background-color: ", ";\n  border-radius: 8px;\n  color: ", ";\n  padding: 16px;\n"], ["\n  text-align: center;\n  margin-bottom: 24px;\n  background-color: ", ";\n  border-radius: 8px;\n  color: ", ";\n  padding: 16px;\n"])), function (props) { return props.theme.colors.tableGray1; }, function (props) { return props.theme.colors.white; });
var MainTitle = styled_components_1.default.h1(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-size: 18px;\n  margin: 0;\n  margin-bottom: 8px;\n"], ["\n  font-size: 18px;\n  margin: 0;\n  margin-bottom: 8px;\n"])));
var SubTitle = styled_components_1.default.h2(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin: 0;\n  font-size: 16px;\n  font-weight: normal;\n"], ["\n  margin: 0;\n  font-size: 16px;\n  font-weight: normal;\n"])));
var Root = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100vw;\n  height: 100vh;\n  background: white;\n  display: flex;\n"], ["\n  width: 100vw;\n  height: 100vh;\n  background: white;\n  display: flex;\n"])));
var Container = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  width: 80vw;\n  max-width: 640px;\n  max-height: 800px;\n  margin: auto;\n"], ["\n  width: 80vw;\n  max-width: 640px;\n  max-height: 800px;\n  margin: auto;\n"])));
var Pre = styled_components_1.default.pre(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 21px;\n  white-space: pre-wrap;\n  margin-bottom: 24px;\n"], ["\n  font-size: 14px;\n  line-height: 21px;\n  white-space: pre-wrap;\n  margin-bottom: 24px;\n"])));
var FileItem = function (props) {
    var index = props.index, job = props.job, file = props.file, onFinish = props.onFinish, useVoucherExternalUpload = props.useVoucherExternalUpload;
    var _a = __read(useVoucherExternalUpload(job.inputs[0].id, job.id), 2), upload = _a[0], status = _a[1];
    react_1.default.useEffect(function () {
        upload(file);
    }, [file, upload]);
    react_1.default.useEffect(function () {
        if (status === file_1.FileUploadStatus.UPLOADED) {
            onFinish(index);
        }
    }, [index, onFinish, status]);
    return null;
};
exports.FileItem = FileItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
